module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMNJREFUeNpi+P//PwMx2GO9LwuMzQgiCAHPDX48QCodiE9sD9h0lKAmoAZuIJUBxOJA/AuIO1igElJA6jvQlPdYNKRBNfwG4nlANV8YgW6Vgkr8AOIZQMEPaBokkTTcBcmBNMkA6VQg5gTid0A8HaoIpEEKyl4A1HAb5gKwn4CmykAVcQDxW6it0lANC4EabiE7Gx4QQI2yUBs5oHJ/oDbcQg8clNADapQDUilAzAq14Qa2EMUIcqBGeZD/cGkAAYAAAwAFXnaB0C6IHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/valid-ok.png
// module id = 1533
// module chunks = 0